import {AvatarBadge, ButtonGroup, IconButton, useSidebarOpen} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

type Language = 'en' | 'he';

const LANGUAGE_ITEMS: {value: Language; label: string}[] = [
  {value: 'en', label: 'English'},
  {value: 'he', label: 'עברית'}
];

export const LanguageSwitcher: FC = () => {
  const {i18n, t} = useTranslation('common');
  const isOpen = useSidebarOpen();
  const collapsed = isOpen === false;

  const isHebrew = i18n.language.startsWith('he');
  const currentLang: Language = isHebrew ? 'he' : 'en';
  const nextLang: Language = isHebrew ? 'en' : 'he';
  const currentBadge = isHebrew ? 'עב' : 'EN';

  const handleChange = (value: string) => {
    void i18n.changeLanguage(value as Language);
  };

  if (collapsed) {
    return (
      <div className="flex w-full items-center justify-center">
        <div className="relative inline-flex">
          <IconButton
            icon="globe"
            aria-label={
              isHebrew
                ? t('languageSwitcher.switchToEnglish')
                : t('languageSwitcher.switchToHebrew')
            }
            onClick={() => handleChange(nextLang)}
            className="size-10 bg-background-secondary"
          />
          <AvatarBadge className="h-auto w-auto px-1 py-px text-[8px] font-bold leading-none">
            {currentBadge}
          </AvatarBadge>
        </div>
      </div>
    );
  }

  return (
    <div dir="ltr" className="w-full">
      <ButtonGroup
        value={currentLang}
        onChange={handleChange}
        items={LANGUAGE_ITEMS}
        className="flex w-full rounded-full [&_button]:flex-1 [&_button]:rounded-full"
      />
    </div>
  );
};
